import React, { useEffect } from 'react';
import { Box, Avatar, Badge } from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { getUserRoleName, getUserName } from '@/utils/helpers';
import { AppDispatch, RootState } from '@/stores';
import { fetchNotificationCount } from '@/stores/notificationSlice';
import NotificationModal from './UI/NotificationListModal';
import { StyledAppBar, StyledContainer, HeaderBox, LogoLink, NotificationIconButton, UserBox, AvatarWrapper, UserInfoBox, UserNameTypography, UserRoleTypography, } from './styles/CustomHeader.styles';
import { Agent, SuperVisor, User } from '@/types';


const CustomHeader: React.FC = () => {
  const user: SuperVisor | null = useAuth();
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>();
  const count = useSelector((state: RootState) => state.notifications.count);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const notificationClick = (event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget);

  const handleClose = () => setAnchorEl(null);

  useEffect(() => {
    dispatch(fetchNotificationCount());
  }, [dispatch]);

  return (
    <StyledAppBar position="static" elevation={0}>
      <StyledContainer maxWidth={false} disableGutters>
        <HeaderBox>
          <LogoLink onClick={() => navigate('/')}>
            <img src="/images/logo-2x.png" alt="Logo" />
          </LogoLink>
          <Box sx={{ display: 'flex', alignItems: 'center', marginLeft: 'auto' }}>
            <NotificationIconButton onClick={notificationClick} >
              {/* <NotificationIconButton onClick={() => navigate('/notifications')} > */}
              <Badge badgeContent={count} color="primary">
                <img src="/images/notification-icon.svg" alt="Notification" width="18px" />
              </Badge>
            </NotificationIconButton>
            <NotificationModal onClose={handleClose} anchorEl={anchorEl} />
            <UserBox onClick={() => navigate('/profile')} sx={{ cursor: 'pointer' }}>
              <AvatarWrapper>
                <Avatar
                  alt={user?.fullName || "User"}
                  src={user?.profileImage}
                  sx={{ width: 38, height: 38 }}
                >
                  {!user?.profileImage && getUserName(user).charAt(0).toUpperCase()}
                </Avatar>
              </AvatarWrapper>
              <UserInfoBox>
                <UserNameTypography>{getUserName(user)}</UserNameTypography>
                <UserRoleTypography>{getUserRoleName(user)}</UserRoleTypography>
              </UserInfoBox>
            </UserBox>
          </Box>
        </HeaderBox>
      </StyledContainer>
    </StyledAppBar>
  );
};

export default CustomHeader;
